__webpack_require__.p = "https://json.mayhem.academy/_next/";